
import { Vue, Component, Prop, ModelSync } from "vue-property-decorator";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { Control } from "@/oxygen/classes/lib/types";
import { mapOptionToDropdown } from "@/oxygen/classes/lib/classes";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { Icon, DropdownInput }
})
export default class OxygenSelectInput extends Vue {
  @Prop()
  control!: Control;

  @ModelSync("value", "input")
  syncedValue?: unknown;

  @Prop()
  placeholder?: unknown;

  get items() {
    return this.control.items?.map(mapOptionToDropdown);
  }
}
